import CreateWorkScopeSpecificationError from "./CreateWorkScopeSpecificationError";

export default class WorkScopeSpecificationRecordAlreadyExistsError extends CreateWorkScopeSpecificationError {

}